import { render, staticRenderFns } from "./AttributeHexSelector.vue?vue&type=template&id=06f207b5"
import script from "./AttributeHexSelector.vue?vue&type=script&lang=js"
export * from "./AttributeHexSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports